import { DeleteOutlined } from '@ant-design/icons'
import { Input, Popconfirm, Button } from 'antd'
import './CollapseHeader.style.less'

interface PropsHeader {
  onChangeName: (value: string) => void
  value: any
  onDeleteSection: () => void
  title: string
  labelStyle?: React.CSSProperties
}

const handleFocus = (event) => {
  event.stopPropagation()
}
function CollapseHeader(props: PropsHeader) {
  const labelStyle = props.labelStyle || {}
  return (
    <div className="section">
      <p className="label-name" style={labelStyle}>
        {props.title}
      </p>
      <Input
        onClick={handleFocus}
        size="large"
        value={props.value.title}
        status= {!props.value.title || String(props.value.title).trim() === '' ? 'error' : ''}
        onChange={(e) => props.onChangeName(e.target.value)}
      />
      <Popconfirm
        placement="topLeft"
        title={'Are you sure you want to delete this item?'}
        onConfirm={props.onDeleteSection}
        okText="Yes"
        cancelText="No"
      >
        <Button
          className="delete-button"
          size="large"
          icon={<DeleteOutlined />}
        />
      </Popconfirm>
    </div>
  )
}
export default CollapseHeader
